/**
 * Uniba Banner reducer
 * @module src/reducers/unibaFooterLinksConfigReducer
 */

import { GET_UNIBA_FOOTER_LINKS } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const unibaFooterLinksConfigReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_FOOTER_LINKS}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_UNIBA_FOOTER_LINKS}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_UNIBA_FOOTER_LINKS}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
